import { Mutations } from 'vuex-smart-module';
import { default_user } from '../services';
import { User } from '../types';
import UserState from './state';

export default class UserMutations extends Mutations<UserState> {
  SET_USER_INFO(user: User.Profile) {
    this.state.me = user;
  }

  SET_USER_EMAIL(email: string) {
    this.state.me.email = email;
  }

  RESET_CURRENT_USER() {
    this.state.me = default_user();
  }

  UPD_ME_FIELD({ key, value }: { key: keyof User.Profile, value: unknown }) {
    this.state.me[key] = value;
  }

  RESET_EDITABLE_ME() {
    this.state.editable_me = { ...this.state.me };
  }

  UPD_EDITABLE_ME_FIELD({ key, value }: { key: keyof User.Profile, value: unknown }) {
    this.state.editable_me[key] = value;
  }

  SET_MAIN_MENU(items: User.MainMenuItem[]) {
    const new_menu = items.map((item) => ({
      ...item,
      active: item.active ?? this.state.main_menu.find((menuItem) => menuItem.id === item.id)?.active,
    }));

    this.state.main_menu = new_menu;
  }

  SET_FAVORITES_MENU(items: User.MainMenuItem) {
    this.state.favorites_menu = items;
  }

  SET_HELP_MENU(items: User.MainMenuItem) {
    this.state.help_menu = items;
  }

  ADD_FAVORITES(item: User.MainMenuItem) {
    if (!this.state.favorites_menu.sub_menu?.includes(item)) {
      item.is_favorite = true;

      if (this.state.favorites_menu.sub_menu) {
        this.state.favorites_menu.sub_menu.push(item);
      }
    }
  }

  DELETE_FAVORITE(item: User.MainMenuItem) {
    function set_favorite_by_id(array: User.MainMenuItem[], id: number) {
      function find_and_set_favorite(arr: User.MainMenuItem[], id: number) {
        const item = arr.find((item: User.MainMenuItem) => item.id === id);

        if (item) {
          item.is_favorite = false;
          return true;
        }
        // eslint-disable-next-line no-restricted-syntax
        for (const item of arr) {
          if (item.sub_menu && item.sub_menu.length > 0) {
            if (find_and_set_favorite(item.sub_menu, id)) {
              return true;
            }
          }
        }
        return false;
      }
      find_and_set_favorite(array, id);
    }

    if (this.state.favorites_menu.sub_menu?.includes(item)) {
      set_favorite_by_id(this.state.favorites_menu.sub_menu, item.id);
    }

    if (this.state.favorites_menu.sub_menu) {
      this.state.favorites_menu.sub_menu = this.state.favorites_menu.sub_menu.filter((el) => el.id !== item.id);
    }
  }

  SET_NEWS_DIALOG_MODAL(value: boolean) {
    this.state.news_dialog_modal = value;
  }
}
